import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { SalesOrderLineRequirement } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class SalesOrderLineRequirementService extends TmsWebBaseEditCreateService<
  SalesOrderLineRequirement,
  SalesOrderLineRequirement
> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('SalesOrderLineRequirement', $localize`Sales Order Line Requirement`);
  }

  createSalesOrderRequirements(
    salesOrderLineId: string,
    salesOrderLineRequirementId?: string,
  ): Observable<SalesOrderLineRequirement[]> {
    return this.httpService.get<SalesOrderLineRequirement[]>(
      `${this.apiUrl}/CreateSalesOrderRequirements/${salesOrderLineId}${
        salesOrderLineRequirementId ? `/${salesOrderLineRequirementId}` : ''
      }`,
    );
  }

  /**
   * `pickListChangeConfirmed` is the Yes to the picking list warning on a make purchase order (see
   * PickListChangeService); a delete has no body, so it travels as a query parameter.
   */
  delete(id: string, pickListChangeConfirmed = false): Observable<any> {
    return this.httpService.delete(
      `${this.apiUrl}/${id}${pickListChangeConfirmed ? '?pickListChangeConfirmed=true' : ''}`,
    );
  }
}
